import ReactCountryFlag from "react-country-flag"
import styles from "./player-list.module.css"
import { TPlayer } from "pages/PlayersPage/types"
import DeleteIcon from 'icons/remove.svg'
import { IconButton } from "entities/IconButton"
import CreateIcon from 'icons/create.svg'

type TArgPlayerList = {
    players: TPlayer[],
    onDeleteClick?: ((playerId: any) => void),
    onAddClick?: ((playerId: any) => void)
}

export const PlayerList = ({
    players,
    onDeleteClick,
    onAddClick
}: TArgPlayerList) => {
    return (
        <div className={styles.App}>
            {players.map((player) => (
                <div className={styles.Player}>
                    <div>
                        {player.country && <ReactCountryFlag
                            svg
                            countryCode={player.country.toLowerCase()}
                            style={{
                                width: '16px',
                                height: '12px',
                            }}
                        />}
                        <div>{player.name}</div>
                    </div>
                    {onDeleteClick && <IconButton icon={DeleteIcon} onClick={() => onDeleteClick(player.id || player._id)} />}
                    {onAddClick && <IconButton icon={CreateIcon} onClick={() => onAddClick(player.id || player._id)} />}
                </div>
            ))}
        </div>
    )
}